import {
    ActionButton,
    FeatureWrap,
    OfficeButton,
    OfficeHeader,
    Paginator,
    RegularBusinessPicker,
    RegularInsurerPicker,
    RegularSelectInput,
    Show,
    TableComponent,
    Tabs,
} from "components";
import { FC, useEffect, useMemo } from "react";
import { useNavigate, useSearch } from "react-location";
import { useUrlState, withPermissions } from "utils";

import { Action } from "components/buttons/action-button";
import AttachSupportingDocumentsContainer from "./attach-supporting-documents";
import { CheckBadgeIcon } from "@heroicons/react/24/solid";
import CreateOfferContainer from "./create";
import { DocumentPlusIcon } from "@heroicons/react/24/outline";
import FilterMenu from "./filter";
import { LocationGenerics } from "router/location";
import { Offers_rows } from "_graphql/queries/__generated__/Offers";
import { PublishedStatus } from "_graphql/__generated__/globalTypes";
import RemoveContainer from "./remove";
import SendMessageContainer from "components/containers/place-it-message-thread";
import UpdateKEKOfferContainer from "./update-kek";
import UpdateOfferContainer from "./update";
import ViewOfferSlipContainer from "./view-slip";
import clsx from "clsx";
import config from "config";
import { getDomain } from "router/filter";
import numeral from "numeral";
import { useFormik } from "formik";
import { useOffers } from "hooks/data/use-offers";
import { usePagination } from "hooks";
import { useUpdateBubble } from "hooks/data/use-update-bubble";

type Props = {};

const tabs = [
    { name: "Open Offers", href: "OPEN" },
    { name: "Pending Offers", href: "PENDING" },
];

const CreateSlipPage: FC<Props> = () => {
    const [modal, setModal] = useUrlState("modal");
    const [orderStatus] = useUrlState("orderStatus");
    const searchParams = useSearch<LocationGenerics>();
    const navigate = useNavigate<LocationGenerics>();
    const { offset, limit, setPage } = usePagination();
    const { updateBubble } = useUpdateBubble();
    const domain = getDomain();

    const form = useFormik({
        initialValues: {
            business: searchParams.business || "",
            offer_from: searchParams.offer_from || "",
            insurer: searchParams.insurer || "",
        },
        onSubmit: () => {},
    });

    const filter = useMemo(
        () => ({
            page: searchParams.page || 1,
            pageSize: searchParams.pageSize || 10,
            search: (searchParams.search || "").toString(),
            args: {
                status: orderStatus ? [orderStatus] : ["PENDING", "OPEN"],
                insurer_id: searchParams.insurer,
                payment_status: [],
                // approval_status: status_type.UNAPPROVED,
                claim_status: [],
                offer_from: searchParams.offer_from || "",
                class_of_business_id: searchParams?.business,
                expiry_status: searchParams?.expiry_status || undefined,
                staff_id: searchParams?.employee || [],
                offset,
                limit,
            },
        }),
        [
            searchParams.insurer,
            form.values.business,
            limit,
            offset,
            orderStatus,
            searchParams.page,
            searchParams.pageSize,
            searchParams.search,
        ],
    );

    const { offers, loading, refetch, count } = useOffers(filter as any);

    const dispatchAction =
        (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
        () => {
            navigate({
                search: (old) => ({
                    ...old,
                    id,
                    modal: action,
                }),
            });
        };

    const expandItem = (id: string) => {
        navigate({
            to: `./${id}/view`,
        });
    };

    const updateThreadBubble = (ids: string[]) => {
        updateBubble({
            variables: {
                ids,
            },
        })
            .then(() => {})
            .catch((err) => {});
    };

    useEffect(() => {
        if (orderStatus) {
            setPage(1);
        }
    }, [orderStatus]);

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <OfficeHeader
                renderActions={() =>
                    withPermissions([
                        "*:*",
                        "offers:*",
                        "offers:manage",
                        "offers:create",
                    ])(
                        <OfficeButton onClick={() => setModal("create")}>
                            <DocumentPlusIcon className="w-5 h-5 mr-2" />
                            Create New Slip
                        </OfficeButton>,
                    )
                }
            />
            <Tabs
                tabs={tabs}
                orderStatus={orderStatus}
                defaultTab="All Offers"
                // renderExtra={() => (
                //   <div className="flex items-center">
                //     <CheckBadgeIcon className="w-5 h-5 text-green-500 mr-2" />
                //     <span className="text-sm font-medium text-white">Published Offers</span>
                //   </div>
                // )}
            />
            {/* {JSON.stringify({ count, limit, offset })} */}
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    <TableComponent
                        title={"offers"}
                        loading={loading}
                        hasSearch
                        // renderHeaderItems={() => (
                        //   <div className="flex items-center gap-x-2">
                        //     <RegularBusinessPicker
                        //       id="business"
                        //       label="Business"
                        //       rawId
                        //       labelHidden
                        //       {...form}
                        //     />
                        //     <FeatureWrap domains={["Visal"]}>
                        //       <RegularSelectInput
                        //         id="offer_from"
                        //         hideLabel
                        //         label="Offer From"
                        //         options={["INTERNAL", "PLACEIT"].map((tab) => ({
                        //           value: tab,
                        //           label: tab,
                        //         }))}
                        //         values={{ offer_from: searchParams?.offer_from || "" }}
                        //         handleChange={(evt: any) => {
                        //           navigate({
                        //             search: (old) => ({
                        //               ...old,
                        //               offer_from: evt.target.value,
                        //               page: 1,
                        //             }),
                        //           });
                        //         }}
                        //       />
                        //     </FeatureWrap>
                        //     <RegularInsurerPicker
                        //       placeholder="Filter by Cedant"
                        //       id={"insurer"}
                        //       label={""}
                        //       rawId
                        //       labelHidden
                        //       {...form}
                        //     />
                        //   </div>
                        // )}
                        renderFilter={({ filterOpen, setFilterOpen }) => (
                            <FilterMenu
                                open={filterOpen}
                                setOpen={setFilterOpen}
                            />
                        )}
                        emptyMessage="No offers found"
                        pagination={() => (
                            <Paginator
                                offset={offset}
                                limit={limit}
                                totalItems={count || 0}
                                currentSize={offers.length}
                                setOffset={setPage}
                            />
                        )}
                        columns={[
                            {
                                name: "Policy #",
                                accessor: "0.policy_number",
                                render: (value: Offers_rows) => (
                                    <div className="flex flex-col items-start flex-wrap break-all break-words">
                                        <div className="flex flex-row items-center gap-x-1">
                                            {value?.offer_published &&
                                                value?.offer_published
                                                    ?.published_status ===
                                                    PublishedStatus.PUBLISHED && (
                                                    <CheckBadgeIcon
                                                        data-tooltip-id="global-tooltip"
                                                        data-tooltip-content="This Offer is Published"
                                                        className={clsx(
                                                            "w-4 h-4 mr-1",
                                                            "text-green-600",
                                                        )}
                                                    />
                                                )}
                                            <span className="font-bold text-xs overflow-hidden text-ellipsis  ">
                                                {value.offer_detail
                                                    ?.policy_number || "N/A"}
                                            </span>
                                        </div>
                                        <div
                                            className={clsx(
                                                "p-0.5 rounded-full",
                                                {
                                                    " text-green-600":
                                                        value.offer_from ===
                                                        "INTERNAL",
                                                    " text-yellow-600":
                                                        value.offer_from !==
                                                        "INTERNAL",
                                                },
                                                "text-xs font-medium",
                                            )}>
                                            <span>{value.offer_from}</span>
                                        </div>
                                    </div>
                                ),
                            },
                            {
                                name: "Insurance Company",
                                accessor: "insurer.insurer_company_name",
                                render: (value: Offers_rows) => (
                                    <div className="flex flex-col text-xs">
                                        <span className="font-medium">
                                            {value.insurer
                                                ?.insurer_company_name || "N/A"}
                                        </span>
                                        <span className="">
                                            {value.insurer
                                                ?.insurer_company_email ||
                                                "N/A"}
                                        </span>
                                    </div>
                                ),
                            },
                            {
                                name: "Insured",
                                accessor: "offer_detail.insured_by",
                                render: (value: Offers_rows) => {
                                    const details = JSON.parse(
                                        value?.offer_detail?.offer_details ||
                                            "[]",
                                    );
                                    return (
                                        <div className="flex flex-col text-xs ">
                                            <span className="font-medium">
                                                {value.offer_detail
                                                    ?.insured_by || "N/A"}
                                            </span>
                                            <span className="">
                                                {[
                                                    "Motor Comprehensive Fleet",
                                                    "Motor Comprehensive",
                                                    "Motor Comprehensive (Automobile Fac Facility)",
                                                ].includes(
                                                    value?.classofbusiness
                                                        ?.business_name || "",
                                                )
                                                    ? details?.find(
                                                          (el: {
                                                              [
                                                                  x: string
                                                              ]: string;
                                                          }) =>
                                                              el?.[
                                                                  "keydetail"
                                                              ] ===
                                                                  "Vehicle Reg No" ||
                                                              el?.[
                                                                  "keydetail"
                                                              ] ===
                                                                  "Vehicle Reg No.",
                                                      )?.value
                                                    : ""}
                                            </span>
                                        </div>
                                    );
                                },
                            },
                            {
                                name: "Class Of Business",
                                accessor: "classofbusiness.business_name",
                                render: (value: Offers_rows) => (
                                    <div className="flex flex-col text-xs">
                                        <span className="font-medium">
                                            {value.classofbusiness
                                                ?.business_name || "N/A"}
                                        </span>
                                    </div>
                                ),
                            },
                            {
                                name: "Sum Insured",
                                accessor: "sum_insured",
                                render: (value: Offers_rows) => (
                                    <div className="flex flex-col text-xs">
                                        <span className="font-medium">
                                            {value?.offer_detail?.currency}{" "}
                                            {numeral(value.sum_insured).format(
                                                "0,0 ",
                                            ) || "N/A"}
                                        </span>
                                    </div>
                                ),
                            },
                            {
                                name: "Rate",
                                accessor: "rate",
                            },
                            {
                                name: "Status",
                                accessor: "offer_status",
                                render: ({ offer_status }: Offers_rows) => (
                                    <span
                                        className={clsx("text-xs", {
                                            "text-blue-600":
                                                offer_status === "OPEN",
                                            "text-yellow-600":
                                                offer_status === "PENDING",
                                        })}>
                                        {offer_status}
                                    </span>
                                ),
                            },
                            {
                                name: "Offer Date",
                                accessor: "created_at",
                                render: (value: Offers_rows) => (
                                    <span>
                                        {new Date(
                                            value.created_at,
                                        ).toLocaleDateString()}
                                    </span>
                                ),
                            },
                            {
                                name: "Created By",
                                accessor: "employee.employee_first_name",
                                render: (value: Offers_rows) => (
                                    <div className="flex flex-row leading-0">
                                        <span>
                                            {
                                                value?.employee
                                                    ?.employee_first_name
                                            }{" "}
                                            {
                                                value?.employee
                                                    ?.employee_last_name
                                            }
                                        </span>
                                    </div>
                                ),
                            },
                            {
                                name: "Actions",
                                accessor: "actions",
                                render: (value: Offers_rows) => (
                                    <>
                                        <ActionButton
                                            action="view"
                                            tooltip="View Docs & History"
                                            onClick={dispatchAction(
                                                value.offer_id +
                                                    ":" +
                                                    value?.offer_from +
                                                    ":" +
                                                    value?.place_it_id,
                                                "resolve",
                                            )}
                                        />
                                        <Show
                                            if={Boolean(
                                                value.offer_from !== "INTERNAL",
                                            )}>
                                            <ActionButton
                                                action="chat"
                                                tooltip="View Message Thread"
                                                onClick={dispatchAction(
                                                    value?.place_it_id || "",
                                                    "chat",
                                                )}
                                                count={
                                                    value.thread_notification?.filter(
                                                        (item) =>
                                                            item?.status !==
                                                            "READ",
                                                    ).length
                                                }
                                                callBack={() =>
                                                    updateThreadBubble(
                                                        value.thread_notification?.map(
                                                            (item) =>
                                                                item?.id || "",
                                                        ) || [],
                                                    )
                                                }
                                            />
                                        </Show>
                                        {withPermissions([
                                            "*:*",
                                            "offers:*",
                                            "offers:manage",
                                            "offers:update",
                                        ])(
                                            <ActionButton
                                                action="update"
                                                tooltip="Edit Offer"
                                                onClick={dispatchAction(
                                                    value.offer_id,
                                                    "update",
                                                )}
                                            />,
                                        )}
                                        <ActionButton
                                            action="resolve"
                                            tooltip="View Offer"
                                            onClick={() =>
                                                expandItem(value?.offer_id)
                                            }
                                        />
                                        <Show
                                            if={
                                                value.offer_from === "INTERNAL"
                                            }>
                                            {withPermissions([
                                                "*:*",
                                                "offers:*",
                                                "offers:manage",
                                                "offers:update",
                                            ])(
                                                <ActionButton
                                                    action="attach"
                                                    tooltip="Add Supporting Documents"
                                                    onClick={dispatchAction(
                                                        value?.offer_id,
                                                        "import",
                                                    )}
                                                />,
                                            )}
                                        </Show>
                                        {withPermissions([
                                            "*:*",
                                            "offers:*",
                                            "offers:manage",
                                            "offers:delete",
                                        ])(
                                            <ActionButton
                                                action="remove"
                                                tooltip={
                                                    domain === "KEK"
                                                        ? "Cancel Offer"
                                                        : "Delete Offer"
                                                }
                                                extraClassName="text-red-500"
                                                onClick={dispatchAction(
                                                    value?.offer_id,
                                                    "remove",
                                                )}
                                            />,
                                        )}
                                    </>
                                ),
                            },
                        ]}
                        data={offers}
                        refetch={refetch}
                        // renderFilter={({ filterOpen, setFilterOpen }) => (
                        //   <FilterMenu
                        //     open={filterOpen}
                        //     setOpen={setFilterOpen}
                        //   />
                        // )}
                        // renderExport={({ exportOpen, setExportOpen }) => (
                        //   <FilterMenu
                        //     open={exportOpen}
                        //     setOpen={setExportOpen}
                        //   />
                        // )}
                    />
                </div>
            </div>
            <CreateOfferContainer
                open={modal === "create"}
                setOpen={(val: boolean) => setModal(val ? "create" : undefined)}
                refetch={refetch}
            />

            {searchParams?.id && modal === "resolve" && (
                <ViewOfferSlipContainer
                    open={modal === "resolve"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "resolve" : undefined)
                    }
                />
            )}
            {searchParams?.id && modal === "remove" && (
                <RemoveContainer
                    open={modal === "remove"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "remove" : undefined)
                    }
                />
            )}
            {searchParams?.id && modal === "update" && (
                <UpdateOfferContainer
                    open={modal === "update"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "update" : undefined)
                    }
                    refetch={refetch}
                />
            )}
            {searchParams?.id &&
                modal === "update" &&
                config.appDomain === "KEK" && (
                    <UpdateKEKOfferContainer
                        open={modal === "update"}
                        setOpen={(val: boolean) =>
                            setModal(val ? "update" : undefined)
                        }
                        refetch={refetch}
                    />
                )}
            {searchParams?.id && modal === "chat" && (
                <SendMessageContainer
                    open={modal === "chat"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "chat" : undefined)
                    }
                />
            )}
            {searchParams?.id && modal === "import" && (
                <AttachSupportingDocumentsContainer
                    open={modal === "import"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "import" : undefined)
                    }
                />
            )}
        </main>
    );
};

export default CreateSlipPage;
